const info = {
  appName: 'Alpha Controller Application',
  shortName: 'Alpha Controller',
  companyName: 'Alpha Controller',
  logo: {
    source: {
      uri: 'logo_alpha.png',
    },
    width: 160,
    height: 71,
  },
  description: 'Alpha Controller App enables high level car inspections with helpers and specific user interfaces.',
  vm: true,
  preferredLanguage: 'de',
  resolution: 'QHD',
};

export default info;
